// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.harti",
    name: "HARTi Wallet",
    homepage: "https://harti.io/",
    image_id: "d0407f26-fe0b-4f3c-43c3-69bc8fef2e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/jp/app/harti/id1599921940?l=en",
        android: "https://play.google.com/store/apps/details?id=app.harti&hl=ja&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "HARTi://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map